import React from 'react';
import {Grid,Divider} from '@material-ui/core'
import CheckBoxInput from '../Inputs/CheckBoxInput'
import CheckBoxDatum from '../Inputs/CheckBoxDatum'
import CheckBoxInputAgare from '../Inputs/CheckBoxInputAgare'
import CheckBoxInputAvtalleverant from '../Inputs/CheckBoxInputAvtalleverant'
import CheckBoxInputAvtalTyp from '../Inputs/CheckBoxInputAvtalTyp'
import CheckBoxInputOrderStatus from '../Inputs/CheckBoxInputOrderStatus'
function index(props) {
    return (
        <>
           <Grid
            container
            direction="row"
            alignItems="center"
            >
               <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="OrderId" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>   
               <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInputAvtalTyp Meta="Ordertyp" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>   
               <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInputAvtalleverant Meta="Order leverantör" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>  
               <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInputAgare Meta="Order ägare" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>  
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order antal" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>  
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order antal ny" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>  
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order antal förlängnig" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>   
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order affär från" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>   
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInputOrderStatus Meta="Order status" disabled={false} OrderStatusList={props.OrderStatusList}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order Etiketter" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={12} className={"p-1"}>
                <Divider/>
                </Grid>
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order värde totalt" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order registrering datum" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order skapad datum" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order värde TB" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order värde TB intäkt" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order värde TB kostnad" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order löpande" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order löpande intäkt" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order löpande kostnad" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order värde Inpris" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Order värde Utpris" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                
                <Grid item xs={12} className={"p-1"}>
                <Divider/>
                </Grid>
                <Grid item xs={6} className={"p-1"}>
                    <CheckBoxDatum Meta="Order skapad datum" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                <Grid item xs={6} className={"p-1"}>
                    <CheckBoxDatum Meta="Order registrering datum" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
            </Grid>

        </>
    );
}

export default index;